if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      imageKey(image) {
        const source = image?.currentSrc || image?.getAttribute('src');
        if (!source) return '';
        try { return new URL(source, document.baseURI).pathname; }
        catch { return source.split('?')[0]; }
      }

      activeMediaFor(opener) {
        if (!opener) return null;
        const id = opener.getAttribute('data-media-id');
        const media = Array.from(this.querySelectorAll('[data-media-id]'));
        let active = media.find((item) => item.dataset.mediaId === id);
        const imageOpener = opener.closest('.product__modal-opener--image');
        const visibleImage = imageOpener?.querySelector('.product__media img');
        const key = this.imageKey(visibleImage);
        if (key) {
          // Resolve the actual displayed photo, even if a variant update left
          // the opener's media ID pointing at an older product image.
          const matchingImage = media.find((item) =>
            item.tagName === 'IMG' && this.imageKey(item) === key
          );
          if (matchingImage) active = matchingImage;
          else {
            const container = this.querySelector('[role="document"]');
            if (!container) return null;
            this.querySelector('[data-ev-current-zoom]')?.remove();
            active = visibleImage.cloneNode(true);
            active.removeAttribute('id');
            active.removeAttribute('class');
            active.setAttribute('data-media-id', id || 'ev-current-image');
            active.setAttribute('data-ev-current-zoom', '');
            active.setAttribute('loading', 'eager');
            active.setAttribute('sizes', '100vw');
            container.appendChild(active);
          }
        }
        return active || null;
      }

      show(opener) {
        const active = this.activeMediaFor(opener);
        if (!active) return;
        super.show(opener);
        this.showActiveMedia(active);
      }

      hide() {
        super.hide();
      }

      showActiveMedia(activeMedia = this.activeMediaFor(this.openedBy)) {
        if (!activeMedia) return;
        this.querySelectorAll('[data-media-id]').forEach((element) =>
          element.classList.toggle('active', element === activeMedia)
        );
        const container = this.querySelector('[role="document"]');
        if (!container) return;
        // Keep the selected photo first so lazy images above it cannot shift
        // the zoom to a different photo while the dialog is opening.
        container.prepend(activeMedia);
        activeMedia.scrollIntoView({ block: 'start', inline: 'center', behavior: 'instant' });
        this.scrollTop = 0;
        container.scrollTop = 0;
        container.scrollLeft = Math.max(0, (activeMedia.clientWidth - container.clientWidth) / 2);
        const template = activeMedia.querySelector('template');
        if (activeMedia.nodeName === 'DEFERRED-MEDIA' &&
            template?.content.querySelector('.js-youtube')) activeMedia.loadContent();
      }
    }
  );
}

